import React from 'react';

const GameSlots = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21 1C22.1045 1.00006 23 1.89547 23 3C23 3.83903 22.4825 4.55564 21.75 4.85254V15C21.75 15.9665 20.9664 16.7499 20 16.75H18.75V19.999C18.75 21.5175 17.519 22.75 16 22.75H4C2.57582 22.75 1.40532 21.667 1.26465 20.2803L1.25 19.999V7.00098C1.24997 5.48245 2.48095 4.25003 4 4.25H16C17.519 4.25002 18.75 5.48247 18.75 7.00098V11.25H20.25V4.85254C19.5174 4.55569 19 3.8391 19 3C19 1.89543 19.8954 1 21 1ZM4 5.75C3.30992 5.75003 2.74999 6.31036 2.75 7.00098V19.999L2.75684 20.127C2.82073 20.7577 3.35295 21.25 4 21.25H16C16.6901 21.25 17.25 20.6896 17.25 19.999V7.00098C17.25 6.31037 16.6901 5.75002 16 5.75H4ZM15 18.75H5V17.25H15V18.75ZM18.75 12.75V15.25H20C20.138 15.2499 20.25 15.138 20.25 15V12.75H18.75ZM14.0771 8.25391C14.4551 8.29258 14.75 8.61187 14.75 9V14C14.75 14.4142 14.4142 14.7499 14 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14V9L5.25391 8.92285C5.29253 8.54489 5.61184 8.25 6 8.25H14L14.0771 8.25391ZM6.75 13.25H13.25V9.75H6.75V13.25Z",
      fill: "white"
    }
  )
);

export { GameSlots };
//# sourceMappingURL=GameSlots.js.map
